import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Empty, Spin } from "antd";
import ActivityTimeline from "./ActivityTimeline";
import BatteryActivityLogModal from "./BatteryActivityLogModal";
import { MOCK_ACTIVITY_GROUPS } from "./mockActivityData";

const BatteryActivityLog = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { batteryActivities, activitiesLoading, activitiesFetched } =
    useSelector((state) => state.batteries);

  const groupsToUse = activitiesFetched
    ? batteryActivities?.groups || []
    : MOCK_ACTIVITY_GROUPS;

  // In the inline view, display Today's activities (or the first group)
  const inlineGroups = groupsToUse.slice(0, 1);

  return (
    <div className="w-full">
      {/* Activity Log Header */}
      <div className="flex items-center justify-between px-6 py-4">
        <h2 className="font-poppins font-medium text-base text-[#000000]">
          Activity Log
        </h2>
        <button
          type="button"
          onClick={() => setIsModalOpen(true)}
          className="w-8 h-8 rounded-md border border-light-grey flex items-center justify-center bg-white hover:bg-background-grey cursor-pointer transition-colors shadow-sm"
          title="Expand Activity Log"
        >
          <img
            src="/assets/icons/maximize-4.svg"
            className="w-4 h-4"
            alt="Expand"
          />
        </button>
      </div>

      <div className="w-full h-[1px] bg-light-grey" />

      {/* Inline Timeline Container */}
      <div className="px-6 pb-2 max-h-[calc(100vh-555px)]  overflow-y-auto">
        {activitiesLoading && (
          <div className="flex items-center justify-center py-8">
            <Spin />
          </div>
        )}

        {!activitiesLoading && groupsToUse.length === 0 && (
          <Empty
            className="py-12"
            description={
              <div className=" text-center text-xs font-poppins text-[#525252]">
                No activity recorded in the last 30 days
              </div>
            }
          />
        )}

        {!activitiesLoading && groupsToUse.length > 0 && (
          <ActivityTimeline groups={inlineGroups} />
        )}
      </div>

      {/* Full History Modal */}
      <BatteryActivityLogModal
        visible={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        activityGroups={groupsToUse}
        loading={activitiesLoading}
      />
    </div>
  );
};

export default BatteryActivityLog;
